import { render, staticRenderFns } from "./AccuracyWarningIcon.vue?vue&type=template&id=64a218bb&scoped=true"
import script from "./AccuracyWarningIcon.vue?vue&type=script&lang=ts"
export * from "./AccuracyWarningIcon.vue?vue&type=script&lang=ts"
import style0 from "./AccuracyWarningIcon.vue?vue&type=style&index=0&id=64a218bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a218bb",
  null
  
)

export default component.exports